import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery } from '../../utils/customBaseQuery';

export const settingsApi = createApi({
	reducerPath: 'settingsApi',
	baseQuery: customBaseQuery,
	tagTypes: ['TopUpRate'],
	endpoints: builder => ({
		getTopUpRate: builder.query({
			query: () => ({
				url: '/top-up-rate',
				method: 'GET',
				prefix: 'settings',
			}),
			providesTags: ['TopUpRate'],
		}),
		updateTopUpRate: builder.mutation({
			query: rateRubPerTl => ({
				url: '/top-up-rate',
				method: 'PUT',
				prefix: 'settings',
				body: { rateRubPerTl },
			}),
			invalidatesTags: ['TopUpRate'],
		}),
	}),
});

export const {
	useGetTopUpRateQuery,
	useUpdateTopUpRateMutation,
} = settingsApi;
